export default __webpack_public_path__ + "static/media/es.5eb0e136.svg";